import SodStatusChip from './SodStatusChip';

export default SodStatusChip;
